/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ApplicationsControllerCreateVersionMutationResponse, ApplicationsControllerCreateVersionPathParams, ApplicationsControllerCreateVersion400, ApplicationsControllerCreateVersion401, ApplicationsControllerCreateVersion403 } from "../../models/checklistsController/ApplicationsControllerCreateVersion";

function getApplicationsControllerCreateVersionUrl(id: ApplicationsControllerCreateVersionPathParams["id"]) {
  const res = { method: 'POST', url: `/api/v1/checklist-applications/${id}/versions` as const }  
  return res
}

/**
 * @description Triggers a re-run of the checklist. Copies forward user answers and reviews. Regenerates AI summaries and sources. Only allowed from the latest version of a family. Requires the create permission on the template kind (Apply/remove reviews or Apply/remove Playbooks).
 * @summary Create a new version of a checklist application
 * {@link /api/v1/checklist-applications/:id/versions}
 */
export async function applicationsControllerCreateVersion(id: ApplicationsControllerCreateVersionPathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ApplicationsControllerCreateVersionMutationResponse, ResponseErrorConfig<ApplicationsControllerCreateVersion400 | ApplicationsControllerCreateVersion401 | ApplicationsControllerCreateVersion403>, unknown>({ method : "POST", url : getApplicationsControllerCreateVersionUrl(id).url.toString(), ... requestConfig })  
  return res.data
}